import {Abi} from 'viem';

export const Tip20Abi: Abi = [
  {
    name: 'transferWithMemo',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      {type: 'address', name: 'to'},
      {type: 'uint256', name: 'amount'},
      {type: 'bytes32', name: 'memo'},
    ],
    outputs: [],
  },
] as const;
